import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  @service cloudAjax;

  async model() {
    try {
      // Fetch list of events from AWS Cloud REST API
      const events = await this.cloudAjax.getEvents();

      console.log('[IndexRoute] Fetched events from AWS:', events);

      return {
        events,
        lastUpdated: new Date()
      };
    } catch (error) {
      console.error('[IndexRoute] Error fetching events:', error);
      return {
        events: [],
        lastUpdated: new Date(),
        error: error.message
      };
    }
  }
}
